module.exports = __webpack_public_path__ + "static/media/INDUSTOWER.88c852dc.txt";